// extracted by mini-css-extract-plugin
module.exports = {"example":"grid-styles-module--example--17fx9"};